import { useState, useEffect } from 'react';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
import AppLoader from '@projectK/components/AppLoader';
 
const WaitlistDashboardMain = (props) => {
  const { isMobile } = useMobileSettings();
  const [component, setComponent] = useState(null);
 
  useEffect(() => {
    const loadComponent = async () => {
      if (isMobile) {
        const module = await import('../MobileComponents/WaitlistDashboardMob');
        setComponent(() => module.default);
      } else {
        const module = await import('../WebComponents/WaitlistDashboardWeb');
        setComponent(() => module.default);
      }
    };
 
    loadComponent();
  }, [isMobile]);
 
  const LoadedComponent = component;
  return component ? <LoadedComponent {...props} /> : <AppLoader />;
};
 
export default WaitlistDashboardMain;
 